import type { ToppingInOrderDetail } from 'shared/domain';

export function toppingSortedByParentId(toppings: ToppingInOrderDetail[]) {
  const baseList = toppings.map((t): ToppingInOrderDetail => ({ ...t }));
  baseList.forEach(topping => {
    const list = baseList.filter(t => t.parentID === topping.toppingNodeId);
    // Grouped topping by name (category) using Arrays
    // src/features/print-management/order-invoice-printing/infra/orderToPrint.adapter.ts
    const listMap = new Map();
    list.forEach(t => {
      const value = listMap.get(t.name);
      if (value === undefined) listMap.set(t.name, [t]);
      else value.push(t);
    });
    topping.children = Array.from(listMap.values()).flat();
  });
  return baseList.filter(t => isNaN(t.parentID));
}
